export default "__VITE_ASSET__CcUEZc0H__"